const init = function () {
    let isAuthenticated = !!window.__isAuthenticated;
    let isOffline = false;
    let checkTimer = null;
    let timeForCheck = 180; // in seconds

    function showOffline() {
        createModal();
        isOffline = true;


        let modal = new window.bootstrap.Modal(document.getElementById('connectionStatusModal'), {
            backdrop: 'static',
            keyboard: false
        });
        modal.show();
    }

    function createModal() {
        let modalElement = document.createElement('div');
        modalElement.className = 'modal fade';
        modalElement.id = 'connectionStatusModal';
        modalElement.tabIndex = -1;
        modalElement.setAttribute('aria-hidden', 'true');

        modalElement.innerHTML =
            '  <div class="modal-dialog modal-dialog-centered">\n' +
            '    <div class="modal-content" style="background:#fff3cd; color:#856404; border:1px solid #ffeeba; border-radius:8px; box-shadow:0 8px 20px rgba(0,0,0,.12);">\n' +
            '      <div class="modal-body" style="font-size:14px; padding:12px 14px;">\n' +
            '        Немає інтернет-з\'єднання. Щойно мережа з\'явиться, продовжимо автоматично.\n' +
            '      </div>\n' +
            '    </div>\n' +
            '  </div>\n'
        ;

        document.body.appendChild(modalElement);
    }

    function handleBackOnline() {
        if (!isOffline) return;

        isOffline = false;
        let modalEl = document.getElementById('connectionStatusModal');
        let modalInstance = window.bootstrap.Modal.getInstance(modalEl);
        if (modalInstance) {
            modalInstance.hide();
        }

        if (!isAuthenticated && window.location.pathname !== '/') {
            window.location.href = '/';
            return;
        }

        window.location.reload();
    }

    function verifyConnection() {
        fetch('/api/connection?connection_check=' + Date.now(), {
            method: 'HEAD',
            cache: 'no-store',
        }).then(function () {
            handleBackOnline();
        }).catch(function () {
            showOffline();
        });
    }

    function initSW() {
        if (!('serviceWorker' in navigator)) return;

        navigator.serviceWorker.register('/service-worker.js').catch(function () {
            // no-op
        });

        navigator.serviceWorker.addEventListener('message', function (event) {
            if (!event || !event.data || event.data.type !== 'connection-status') return;

            if (event.data.status === 'offline') {
                showOffline();
            }

            if (event.data.status === 'online') {
                handleBackOnline();
            }
        });
    }

    window.addEventListener('offline', showOffline);
    window.addEventListener('online', handleBackOnline);

    if (!navigator.onLine) {
        showOffline();
    }

    initSW();

    checkTimer = setInterval(verifyConnection, timeForCheck * 1000);
}
export default {init};

// (function () {
//   let  isAuthenticated = !!window.__isAuthenticated;
//   let  isOffline = false;
//   let  checkTimer = null;
//
//   function ensureBanner() {
//     let  existing = document.getElementById('connection-status-banner');
//     if (existing) return existing;
//
//     let  banner = document.createElement('div');
//     banner.id = 'connection-status-banner';
//     banner.style.position = 'fixed';
//     banner.style.left = '12px';
//     banner.style.right = '12px';
//     banner.style.bottom = '12px';
//     banner.style.zIndex = '2500';
//     banner.style.padding = '12px 14px';
//     banner.style.borderRadius = '8px';
//     banner.style.background = '#fff3cd';
//     banner.style.color = '#856404';
//     banner.style.border = '1px solid #ffeeba';
//     banner.style.boxShadow = '0 8px 20px rgba(0,0,0,.12)';
//     banner.style.fontSize = '14px';
//     banner.style.display = 'none';
//     banner.textContent = "Немає інтернет-з'єднання. Щойно мережа з'явиться, продовжимо автоматично.";
//
//     document.body.appendChild(banner);
//     return banner;
//   }
//
//   function showOffline() {
//     isOffline = true;
//     ensureBanner().style.display = 'block';
//   }
//
//   function handleBackOnline() {
//     if (!isOffline) return;
//
//     isOffline = false;
//     let  banner = ensureBanner();
//     banner.style.display = 'none';
//
//     if (!isAuthenticated && window.location.pathname !== '/') {
//       window.location.href = '/';
//       return;
//     }
//
//     window.location.reload();
//   }
//
//   function verifyConnection() {
//     fetch('/?connection_check=' + Date.now(), {
//       method: 'HEAD',
//       cache: 'no-store',
//     }).then(function () {
//       handleBackOnline();
//     }).catch(function () {
//       showOffline();
//     });
//   }
//
//   function initSW() {
//     if (!('serviceWorker' in navigator)) return;
//
//     navigator.serviceWorker.register('/service-worker.js').catch(function () {
//       // no-op
//     });
//
//     navigator.serviceWorker.addEventListener('message', function (event) {
//       if (!event || !event.data || event.data.type !== 'connection-status') return;
//
//       if (event.data.status === 'offline') {
//         showOffline();
//       }
//
//       if (event.data.status === 'online') {
//         handleBackOnline();
//       }
//     });
//   }
//
//   window.addEventListener('offline', showOffline);
//   window.addEventListener('online', handleBackOnline);
//
//   if (!navigator.onLine) {
//     showOffline();
//   }
//
//   initSW();
//
//   checkTimer = setInterval(verifyConnection, 10000);
// })();
